import {ajax,getRequestUrl,formatData} from "../request";
export default {
  // 列表
  adminRolesList(data, method) {
    return ajax('post', getRequestUrl('/role/list'), data, {
      method,
    });
  },

  usersPowerUidModule(data, method) {
    return ajax('post', getRequestUrl('/api/Admin/usersPowerUidModule'), data, {
      method,
    });
  },

  usersPowerUidModuleSet(data, method) {
    return ajax('post', getRequestUrl('/api/Admin/usersPowerUidModuleSet'), data, {
      method,
    });
  },

  checkAdminPwd(data) {
    return ajax('post', getRequestUrl('/api/Admin/checkAdminPwd'), data);
  },

  accountList(data, method) {
    return ajax('post', getRequestUrl('/setting/adminList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  findAdmin(data, method) {
    return ajax('post', getRequestUrl('/api/Admin/findAdmin'), data, {
      method,
    });
  },

  createAdmin(data, method) {
    return ajax('post', getRequestUrl('/setting/createAdmin'), data, {
      method,
    });
  },

  updateAdmin(data, method) {
    return ajax('post', getRequestUrl('/setting/updateAdmin'), data, {
      method,
    });
  },

  deleteAdmin(data, method) {
    return ajax('post', getRequestUrl('/setting/deleteAdmin'), data, {
      method,
    });
  },

  changeAdminStatus(data, method) {
    return ajax('post', getRequestUrl('/setting/changeAdminStatus'), data, {
      method,
    });
  },

  propSendLimitList(data, method) {
    return ajax('post', getRequestUrl('/api/Admin/propSendLimitList'), data, {
      method,
    });
  },

  propSendLimitSet(data, method) {
    return ajax('post', getRequestUrl('/api/Admin/propSendLimitSet'), data, {
      method,
    });
  },
}



// WEBPACK FOOTER //
// ./src/js/https/admin.js